import { useContext } from "react";

import { useTranslation } from "react-i18next";

import Button, {
    BUTTON_COLORS,
    BUTTON_SIZES,
    BUTTON_VARIANTS
} from "components/DesignComponents/Button";
import ActionToolbarButtonWrapper from "components/DesignComponents/Button/ActionToolbarButtonWrapper";
import TableContext from "context/table/tableContext";
import { useMediaQueries, usePermissions } from "shared";

import CreateGroup from "../dialogs/DeviceGroups/CreateGroup";
import MoveGroup from "../dialogs/DeviceGroups/MoveGroup";
import { GROUP_ACTIONS } from "../types";
import ContentFrame from "./components/ContentFrame";
import { useDialog } from "./hooks";

const DeviceGroupsBar = () => {
    const { isInitialLoading } = useContext(TableContext);

    const { t } = useTranslation();
    const { toSm } = useMediaQueries();
    const { isOpenDialog, openDialog, closeDialog } = useDialog();

    const {
        isCreateDeviceGroupNotAllowed,
        isUpdateDeviceGroupNotAllowed,
        PERMISSIONS
    } = usePermissions();

    return (
        <>
            <ContentFrame>
                <ActionToolbarButtonWrapper
                    permissionName={PERMISSIONS.DeviceGroupCreate}
                >
                    <Button
                        fullWidth={toSm}
                        hasRectangleLoader={toSm && isInitialLoading}
                        color={BUTTON_COLORS.Primary}
                        size={BUTTON_SIZES.Small}
                        variant={BUTTON_VARIANTS.TextOnly}
                        disabled={isCreateDeviceGroupNotAllowed}
                        onClick={() => openDialog(GROUP_ACTIONS.CreateGroup)}
                    >
                        {t("Button##create")}
                    </Button>
                </ActionToolbarButtonWrapper>

                <ActionToolbarButtonWrapper
                    permissionName={PERMISSIONS.DeviceGroupUpdate}
                >
                    <Button
                        fullWidth={toSm}
                        hasRectangleLoader={toSm && isInitialLoading}
                        variant={BUTTON_VARIANTS.TextOnly}
                        size={BUTTON_SIZES.Small}
                        color={BUTTON_COLORS.White}
                        disabled={isUpdateDeviceGroupNotAllowed}
                        onClick={() =>
                            openDialog(GROUP_ACTIONS.MoveDeviceGroup)
                        }
                    >
                        {t("Button##move")}
                    </Button>
                </ActionToolbarButtonWrapper>
            </ContentFrame>

            <CreateGroup
                isOpen={isOpenDialog[GROUP_ACTIONS.CreateGroup]}
                close={closeDialog}
            />

            <MoveGroup
                isOpen={isOpenDialog[GROUP_ACTIONS.MoveDeviceGroup]}
                close={closeDialog}
            />
        </>
    );
};

export default DeviceGroupsBar;
